// Portuguese translations
export const pt = {
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Criar',
    search: 'Pesquisar',
    loading: 'A carregar...',
    noResults: 'Sem resultados',
    confirm: 'Confirmar',
    yes: 'Sim',
    no: 'Não',
    back: 'Voltar',
    next: 'Seguinte',
    close: 'Fechar',
    export: 'Exportar',
    import: 'Importar'
  },
  auth: {
    login: 'Entrar',
    logout: 'Sair',
    register: 'Registar',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Esqueceu a password?',
    resetPassword: 'Recuperar password',
    noAccount: 'Não tem conta?',
    hasAccount: 'Já tem conta?'
  },
  navigation: {
    dashboard: 'Dashboard',
    consents: 'Consentimentos',
    titulars: 'Titulares',
    groups: 'Grupos & Campanhas',
    analytics: 'Analytics',
    expiringAlerts: 'Alertas Expiração',
    rtbf: 'Dir. Esquecimento',
    qrCode: 'QR Code',
    otpValidation: 'Validação OTP',
    exportData: 'Exportar Dados',
    marketingActions: 'Ações de Marketing',
    importExport: 'Importar/Exportar',
    users: 'Utilizadores',
    dataBreaches: 'Violações de Dados',
    backups: 'Backups',
    auditLogs: 'Logs de Auditoria',
    settings: 'Definições'
  },
  consents: {
    title: 'Gestão de Consentimentos',
    newConsent: 'Novo Consentimento',
    activeConsents: 'Consentimentos Ativos',
    revokedConsents: 'Consentimentos Revogados',
    pendingConsents: 'Consentimentos Pendentes',
    purposes: {
      newsletter: 'Newsletter',
      promotions: 'Promoções',
      events: 'Eventos',
      surveys: 'Inquéritos',
      productUpdates: 'Atualizações de Produto'
    },
    status: {
      active: 'Ativo',
      revoked: 'Revogado',
      pending: 'Pendente',
      expired: 'Expirado'
    },
    evidence: 'Evidência',
    expirationDate: 'Data de Expiração',
    retentionPeriod: 'Prazo de Conservação'
  },
  titulars: {
    title: 'Gestão de Titulares',
    newTitular: 'Novo Titular',
    editTitular: 'Editar Titular',
    groups: 'Grupos',
    noGroups: 'Sem grupos'
  },
  groups: {
    title: 'Grupos de Titulares',
    newGroup: 'Novo Grupo',
    editGroup: 'Editar Grupo',
    members: 'Membros',
    addMembers: 'Adicionar Membros'
  },
  campaigns: {
    title: 'Campanhas de Marketing',
    newCampaign: 'Nova Campanha',
    purpose: 'Finalidade',
    legalBasis: 'Base Legal',
    targetGroups: 'Grupos Alvo',
    status: {
      draft: 'Rascunho',
      pendingApproval: 'Aguarda Aprovação',
      approved: 'Aprovado',
      executed: 'Executado',
      cancelled: 'Cancelado'
    },
    approve: 'Aprovar',
    execute: 'Executar'
  },
  ropa: {
    title: 'Registo de Atividades de Tratamento',
    exportPdf: 'Exportar PDF',
    exportExcel: 'Exportar Excel'
  },
  notifications: {
    title: 'Notificações',
    noNotifications: 'Sem notificações',
    markAllRead: 'Marcar todas',
    viewAll: 'Ver todas'
  },
  settings: {
    title: 'Definições',
    language: 'Idioma',
    theme: 'Tema',
    lightTheme: 'Claro',
    darkTheme: 'Escuro',
    autoTheme: 'Automático'
  }
};
